import { Fragment } from 'react'
import { createElement } from '@vivaldis/common'
import { Space } from '@vivaldis/antd-ui'
import { ComponentType, ReactElement } from 'react'

export interface NavigationBarActionButtonsProps {
  actions: (ComponentType | ReactElement<any> | null)[]
}

export const ActionButtons = ({ actions }: NavigationBarActionButtonsProps) => {
  return (
    <Space size="small">
      {actions.map((action, index) => (
        <Fragment key={index}>{createElement(action)}</Fragment>
      ))}
    </Space>
  )
}
